import styles from "./Button.module.css";
export default function Button({ variant = "primary", size = "md", fullWidth = false, className = "", ...props }) {
  return <button className={`${styles.button} ${styles[variant]} ${styles[size]} ${fullWidth ? styles.fullWidth : ""} ${className}`} {...props} />;
}
